import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Layouts
import ClientLayout from './layouts/ClientLayout';
import AdminLayout from './layouts/AdminLayout';

// Client Pages
import ContractCatalog from './pages/client/ContractCatalog';
import ContractDetails from './pages/client/ContractDetails';
import Cart from './pages/client/Cart';
import Checkout from './pages/client/Checkout';
import Questionnaire from './pages/client/Questionnaire';
import OrderTracking from './pages/client/OrderTracking';
import ClientMessages from './pages/client/Messages';
import ClientProfile from './pages/client/Profile';

// Admin Pages
import Dashboard from './pages/admin/Dashboard';
import ContractManagement from './pages/admin/ContractManagement';
import OrderManagement from './pages/admin/OrderManagement';
import QuestionnaireBuilder from './pages/admin/QuestionnaireBuilder';
import AdminMessages from './pages/admin/Messages';
import ClientManagement from './pages/admin/ClientManagement';
import Reports from './pages/admin/Reports';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';

// Context
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { ContractProvider } from './context/ContractContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ContractProvider>
          <CartProvider>
            <Toaster position="top-right" />
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              
              {/* Client Routes */}
              <Route path="/" element={<ClientLayout />}>
                <Route index element={<ContractCatalog />} />
                <Route path="contracts" element={<ContractCatalog />} />
                <Route path="contracts/:id" element={<ContractDetails />} />
                <Route path="cart" element={<Cart />} />
                <Route path="checkout" element={
                  <ProtectedRoute>
                    <Checkout />
                  </ProtectedRoute>
                } />
                <Route path="questionnaire/:orderId" element={
                  <ProtectedRoute>
                    <Questionnaire />
                  </ProtectedRoute>
                } />
                <Route path="orders" element={
                  <ProtectedRoute>
                    <OrderTracking />
                  </ProtectedRoute>
                } />
                <Route path="messages" element={
                  <ProtectedRoute>
                    <ClientMessages />
                  </ProtectedRoute>
                } />
                <Route path="profile" element={
                  <ProtectedRoute>
                    <ClientProfile />
                  </ProtectedRoute>
                } />
              </Route>
              
              {/* Admin Routes */}
              <Route path="/admin" element={
                <ProtectedRoute adminOnly>
                  <AdminLayout />
                </ProtectedRoute>
              }>
                <Route index element={<Dashboard />} />
                <Route path="contracts" element={<ContractManagement />} />
                <Route path="orders" element={<OrderManagement />} />
                <Route path="questionnaires" element={<QuestionnaireBuilder />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="clients" element={<ClientManagement />} />
                <Route path="reports" element={<Reports />} />
              </Route>
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </CartProvider>
        </ContractProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;